import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import AICreditsUsageReportComponent from './AICreditsUsageReportPage';

import { set } from '../../../store/actions/pages';
import { dateEquators, integerEquators, StringEquators } from '../../../store/constants/pages';
import { createCurrencyDataField, createIconDataField, createNumberDataField, createStringDataField, createTimestampField } from '../../../util/format';
import { createFilteredSortedDataSelector } from '../../../util/selector';
import { aiCreditsUsageReportLanding, aiDownloadCreditUsageReport, aiResetCreditUsageReport } from "../../../store/actions/creditUsage";
import { getEndDate, getStartDate } from "../../../util/date";

const DEFAULT_SORT = [{ id: 'userName', direction: 'asc' }];

const selectFields = createSelector(
    () => [
        createStringDataField('userName', 'User Name', { sortable: true, equators: StringEquators }),
        createStringDataField('userRole', 'User Role', { sortable: true, equators: StringEquators }),
        createStringDataField('processingType', 'Processing Type', { sortable: true, equators: StringEquators }),
        createNumberDataField('creditCount', 'Credit Count', { sortable: true, equators: integerEquators }),
        createStringDataField('timestamp', 'Timestamp', { sortable: true, equators: dateEquators }),
    ]
);

const selectDataList = (state) => state.creditUsage.aiData;

const selectFilteredFields = createSelector(
    selectFields,
    (fields) => {
        return fields.map(field => field.id);
    }
);

const selectSort = createSelector(
    (state, props) => state.pages[`ai-credits-usage-report-landing`].sort,
    (sort) => sort || DEFAULT_SORT,
);

const selectFilteredData = createFilteredSortedDataSelector(
    selectFilteredFields,
    (state, props) => state.pages[`ai-credits-usage-report-landing`].filter,
    selectSort,
    selectDataList,
);

const initialDates = () => {
    return {
        beginDate: getStartDate('Last12Months'),
        endDate: getEndDate('Last12Months'),
    }
}

export const AICreditsUsageReport = connect(
    () => {
        return (state, props) => ({
            listPending: state.creditUsage.aiList.pending,
            fields: selectFields(state as never),
            filteredData: selectFilteredData(state, props),
            order: state.pages[`ai-credits-usage-report-landing`].order,
            filter: state.pages[`ai-credits-usage-report-landing`].filter,
            sort: selectSort(state, props),
            initialDates: initialDates,
            downloadReportPending: state.creditUsage.aiDownload.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            creditsUsageReportLanding: aiCreditsUsageReportLanding,
            downloadCreditUsageReport: aiDownloadCreditUsageReport,
            setFilter: (value) => set(`ai-credits-usage-report-landing`, 'filter', value),
            setOrder: (value) => set(`ai-credits-usage-report-landing`, 'order', value),
            setSort: (value) => set(`ai-credits-usage-report-landing`, 'sort', value),
            resetTable: aiResetCreditUsageReport
        }, dispatch)
    })
)(injectIntl(AICreditsUsageReportComponent));